import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {useNavigate} from "react-router";
import axios from "../../../helpers/axios";
import {Helmet} from "react-helmet";
import BlockUi from "@availity/block-ui";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import TripCheckForm from "../components/TripCheckForm";
import { v4 as uuidv4 } from 'uuid';
import {Col, Row} from "react-bootstrap";
import LoadingButton from "../../base/components/loadingButton";
import {TripCheckListRoute} from "../../routesConstants";


const TripCheckEdit = () => {
  const {id} = useParams();
  const [loading, setLoading] = useState(false)
  const navigate=useNavigate()
  const [data, setData] = useState()
  const [firstLoad, setFirstLoad] = useState(true)


  useEffect(() => {
    if(id){
      axios.get('/api/tripCheck/'+id)
        .then(({data})=>{
          data.tripCheck.days.forEach(day=>{
            day.items.forEach(item=>{
              item.id = uuidv4()
              item.column = day.date
            })
          })
          setData(data.tripCheck)
        })
    }
  }, [id]);

  const saveData = (data) =>{
    setFirstLoad(true)
    setLoading(true)
    axios.patch('/api/tripCheck/'+id, data)
      .then(({data})=>{
        data.tripCheck.days.forEach(day=>{
          day.items.forEach(item=>{
            item.id = uuidv4()
            item.column = day.date
          })
        })
        setData(data.tripCheck)
      })
      .finally(()=>setLoading(false))
  }
  const removeAll = () =>{
    if(window.confirm('Удалить чек-лист?')){
      setLoading(true)
      axios.delete('/api/tripCheck/'+id)
        .then(()=>navigate(TripCheckListRoute))
        .finally(()=>setLoading(false))
    }
  }

  return (
    <>
      <Helmet>
        {data ? data.name : 'Редактирование чек-листа'}
      </Helmet>
      <BlockUi blocking={!data}>
        {data &&
          <Row>
            <Col lg={7}>
              <Portlet>
                <PortletHeader title={'Чек-лист услуги'}
                               toolbar={<PortletHeaderToolbar>
                                 <LoadingButton onClick={removeAll} loading={false} title={'Удалить'} variant={'danger'}/>
                               </PortletHeaderToolbar>}/>
                <PortletBody>
                  <TripCheckForm data={data}
                                 cb={saveData}
                                 firstLoad={firstLoad}
                                 setFirstLoad={setFirstLoad}/>
                </PortletBody>
              </Portlet>
            </Col>
            <Col>
              {loading ? 'Сохранение...' : 'Сохранено'}
            </Col>
          </Row>
          }

      </BlockUi>
    </>
  );
};

export default TripCheckEdit;
